// extracted by mini-css-extract-plugin
module.exports = {"pendingReservationCard":"pendingReservationCard_pendingReservationCard__xs0rV"};